// @flow
import * as React from "react";
import { useState } from "react";
import { useToasts } from "react-toast-notifications";
import { useHistory } from "react-router-dom";
import { loadStripe } from "@stripe/stripe-js";
import axios from "axios";

export function PriceGroup({ price, idx, isLoggedIn }) {
  let stripePromise;
  const { addToast } = useToasts();
  const history = useHistory();
  const [stripeError, setStripeError] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const mail = localStorage.getItem("email");

  const getStripe = () => {
    if (!stripePromise) {
      stripePromise = loadStripe(
        process.env.REACT_APP_stripe_webhook_signing_secret
      );
    }
    return stripePromise;
  };
  const item = {
    price: `${price.priceID[0].priceId}`,
    quantity: 1,
  };
  const checkoutOptions = {
    lineItems: [item],
    mode: "subscription",
    successUrl: `${window.location.origin}/success`,
    cancelUrl: `${window.location.origin}/cancel`,
    customerEmail: `${mail}`,
  };
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({
      price: `${price.priceID[0].priceId}`,
      quantity: 1,
      email: mail,
    }),
  };
  const redirectToCheckout = async () => {
    if (isLoggedIn === false) {
      addToast("You must create an account first", {
        appearance: "error",
        autoDismiss: "true",
      });
      setTimeout(() => {
        history.push("/login");
      }, 3000);
    } else {
      setLoading(true);
      const res = await fetch(
        `https://stripe-node-vx6pg.ondigitalocean.app/create-checkout-session`,
        requestOptions
      );
      const body = await res.json();
      window.location.href = body.url;

      //   const stripe = await getStripe();
      //   const { error } = await stripe.redirectToCheckout(checkoutOptions);
      //   console.log("Stripe checkout error", error);

      //   if (error) setStripeError(error.message);
      // setLoading(false);
    }
  };
  if (stripeError) alert(stripeError);

  return (
    <div
      className="pricingCard"
      onClick={redirectToCheckout}
      disabled={isLoading}
    >
      <div className="pricingText">
        <h2>
          {price.planDay}
          <span className="priceTerm"> {price.priceTerm}</span>
        </h2>
      </div>
      <div className="purchaseButton">
        {isLoading ? "Loading..." : "Purchase"}
      </div>
    </div>
  );
}

export default PriceGroup;
